// <s-footer-disclosures> turns the footer link columns into collapsed +/− disclosures below md
// and keeps them permanently open (non-toggling, out of the tab order) at md and up.
class FooterDisclosures extends HTMLElement {
  #query = window.matchMedia('(min-width: 48rem)');
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#query.addEventListener('change', () => this.#apply(), { signal });
    this.addEventListener('click', (event) => {
      if (!this.#query.matches) return;
      if (event.target instanceof Element && event.target.closest('summary')) event.preventDefault();
    }, { signal });
    this.#apply();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #apply() {
    const desktop = this.#query.matches;
    this.querySelectorAll(':scope > details').forEach((details) => {
      details.open = desktop;
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;
      if (desktop) summary.setAttribute('tabindex', '-1');
      else summary.removeAttribute('tabindex');
    });
  }
}

if (!customElements.get('s-footer-disclosures')) customElements.define('s-footer-disclosures', FooterDisclosures);
